import { useQuery } from 'react-query'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { IOption } from '@user/components/Filters'

export const useSoldServiceStatuses = () => {
  return useQuery(
    ['filters', 'opp', 'soldServiceStatuses'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters('opportunities', 'SoldServiceStatuses')}`,
      )

      const statuses: string[] = await result.json()

      // 🔹 Map each string into an IOption object
      const options: IOption[] = statuses.map((status) => ({
        label: status,
        value: status,
      }))

      return options
    },
  )
}
